export const INIT_USER = 'INIT_USER';
export const RESET_USER = 'RESET_USER';
export const SET_USER_LOADING = 'SET_USER_LOADING';
export const UPDATE_USER_INFO = 'UPDATE_USER_INFO';
